import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// Office.js loaded via <script> in index.html. Wait for it before mounting.
Office.onReady(() => {
  const root = document.getElementById("root");
  if (!root) throw new Error("Missing #root");
  createRoot(root).render(<App />);
});
